import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { RootState, closeCallMeModal, closeContactModal, closeTermsAndConditionsAdditionalModal, useAppDispatch, useAppSelector, useFixedHeaderOffsetPx } from 'src/common';
import { CallMeModal, ContactModal, Content, Footer, Header, Loader, Message } from 'src/components';
import { TermsAndConditionsAdditionalModal } from 'src/components/modals/termsAndConditionsAdditional.modal';


const AppRouter = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const isAdditional = pathname.includes('dodatno-zdravstveno-osiguranje');
  const [headerExpanded, setHeaderExpanded] = useState<boolean>(false);
  const contentPaddingTopPx = useFixedHeaderOffsetPx();

  const callMeModalOpen = useAppSelector((store: RootState) => store.state?.modal?.callMeModal?.open ?? false);
  const contactModalOpen = useAppSelector((store: RootState) => store.state?.modal?.contactModal?.open ?? false);
  const globalLoading = useAppSelector((store: RootState) => store.ui?.global ?? false);
  const termsAndConditionsAdditionalModalOpen = useAppSelector((store: RootState) => store.state?.modal?.termsAndConditionsAdditionalModal?.open ?? false);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    scrollToTop();
    const frame = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop);
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname]);

  return (
    <>
      {globalLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
          }}
        >
          <Loader size={48} />
        </div>
      )}
      <Header expanded={headerExpanded} handleStyleExpansion={setHeaderExpanded}/>
      <Content paddingTopPx={(pathname.includes('print-health-questionnaire') || pathname.includes('agent-edit-health-questionnaire')) ? 0 : contentPaddingTopPx}>
        <Message />
        <Outlet />
      </Content>
      <Footer />

      <CallMeModal open={callMeModalOpen} onClose={() => dispatch(closeCallMeModal())} isAdditional={isAdditional} />
      <ContactModal open={contactModalOpen} onClose={() => dispatch(closeContactModal())} />
      <TermsAndConditionsAdditionalModal open={termsAndConditionsAdditionalModalOpen} onClose={() => dispatch(closeTermsAndConditionsAdditionalModal())} />
    </>
  )
};

export default AppRouter;